import { ExceptionsService } from "../services/utelize/general/exceptions-service";
import { OurDate } from "../interfaces/general/our-date";

export function getUtcTimestamp(exceptionsService: ExceptionsService
                               ): string | undefined {
  try {
    const now    =new Date();
    const year   =now.getUTCFullYear();
    const month  =String(now.getUTCMonth() + 1).padStart(2, '0');
    const day    =String(now.getUTCDate()).padStart(2, '0');
    const hours  =String(now.getUTCHours()).padStart(2, '0');
    const minutes=String(now.getUTCMinutes()).padStart(2, '0');
    const seconds=String(now.getUTCSeconds()).padStart(2, '0');
    const millis =String(now.getUTCMilliseconds()).padStart(3, '0');
    
    return `${year}${month}${day}${hours}${minutes}${seconds}${millis}`;
  }
  catch(e) {
    exceptionsService.handleException(<Error>e);
    return undefined;
  }
}

export function populateOurDate(exceptionsService: ExceptionsService,
                                date             : Date | number | string,
                               ): OurDate | undefined {
  try {
    let _date: Date           =new Date(date);
    let day  : number | string=_date.getUTCDate();
    let month: number | string=_date.getUTCMonth()+1;
    let year : number         =_date.getUTCFullYear();
    
    if (day<10)
      day="0"+day;
    
    if (month<10)
      month="0"+month;
    
    return {
      date : _date,
      day  : day,
      month: month,
      year : year
    };
  }
  catch(e) {
    exceptionsService.handleException(<Error>e);
    return undefined;
  }
}
